"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    teamsDarkTheme: ()=>_tokens.teamsDarkTheme,
    teamsHighContrastTheme: ()=>_tokens.teamsHighContrastTheme,
    teamsLightTheme: ()=>_tokens.teamsLightTheme,
    webDarkTheme: ()=>_tokens.webDarkTheme,
    webLightTheme: ()=>_tokens.webLightTheme,
    createDarkTheme: ()=>_tokens.createDarkTheme,
    createHighContrastTheme: ()=>_tokens.createHighContrastTheme,
    createLightTheme: ()=>_tokens.createLightTheme,
    createTeamsDarkTheme: ()=>_tokens.createTeamsDarkTheme,
    themeToTokensObject: ()=>_tokens.themeToTokensObject,
    tokens: ()=>_tokens.tokens,
    typographyStyles: ()=>_tokens.typographyStyles
});
const _tokens = require("@fluentui/tokens");
 //# sourceMappingURL=index.js.map

//# sourceMappingURL=index.js.map